import {lazyRegister} from '@/Core/lazyRegister';
import './sidebar.component.css';
import template from './sidebar.component.html';
import '@components/Forms/container/sidebar/sidebar-menu/sidebar-menu.component';

class SidebarController {
    static $inject = ['$element', '$transclude'];
    isFooterFilled: boolean;
    isHeaderFilled: boolean;
    hasHeader: boolean;
    hasFooter: boolean;
    isCollapsed: boolean = false;

    constructor(private $element,
                private $transclude: ng.ITranscludeFunction) {
    }

    $onInit(): void {
        this.$element.addClass('sidebar');
        this.hasHeader = this.isHeaderFilled ?? this.$transclude.isSlotFilled('header');
        this.hasFooter = this.isFooterFilled ?? this.$transclude.isSlotFilled('footer');
    }

    toggleCollapse(): void {
        this.isCollapsed = !this.isCollapsed;
        if (this.isCollapsed) {
            this.$element.addClass('sidebar-collapsed');
        } else {
            this.$element.removeClass('sidebar-collapsed');
        }
    }
}

export const SidebarComponent: ng.IComponentOptions = {
    transclude: {
        header: '?sidebarHeader',
        footer: '?sidebarFooter',
        body: 'sidebarBody'
    },
    bindings: {
        isHeaderFilled: '<?',
        isFooterFilled: '<?'
    },
    template: template,
    controller: SidebarController
};

lazyRegister.component('sidebar', SidebarComponent);